// src/store/businessSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessProfileId } from '../services/businessService';

export const fetchBusinessId = createAsyncThunk(
  'business/fetchBusinessId',
  async () => {
    const response = await getBusinessProfileId();
    return response; 
  }
);

const businessSlice = createSlice({
  name: 'business',
  initialState: {
    id: null,
    image: null, // add image to state
    status: 'idle',
    error: null,
  },
  reducers: {
    clearBusinessProfile: (state) => {
      state.id = null;
      state.logo = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBusinessId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.id = action.payload.id;
        state.image = action.payload.image; // set image
      })
      .addCase(fetchBusinessId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { clearBusinessProfile } = businessSlice.actions;

export default businessSlice.reducer;